export default __webpack_public_path__ + "static/drum-crash-f857b34fa80a40805cb8aae407bd446e.wav";